<template>
    <div class="switching-img" @mouseleave.passive="leave" @mousemove.passive="updateMouseMove" ref="container">
        <common-number-picture :src="suggestPicture ?? images[currentIdx]!" :size="size" :eager="eager"></common-number-picture>
        <div class="bullets" :class="{hide: !!suggestPicture}" v-if="images.length > 1">
            <div class="bullet" v-for="(_, i) of images" :key="i" :class="{active: i === currentIdx}"></div>
            <div class="active-bullet" :class="direction" :style="{'--l': currentIdx}"></div>
        </div>
    </div>
</template>

<script setup lang="ts">

const props = defineProps<{
    images: number[];
    size: string;
    suggestPicture?: number | null;
    eager?: boolean;
}>();

const usePosition = ref(false);
const idx = ref(0);
const direction = ref('right');

const container = ref<HTMLElement>();


function updateMouseMove(event: any) {
    const rect = container.value?.getBoundingClientRect();

    if (!rect) {
        return;
    }

    usePosition.value = true;
    idx.value = Math.trunc(event.layerX / rect!.width * props.images.length);
    if (idx.value > props.images.length - 1) {
        idx.value = props.images.length - 1;
    }
}

function leave() {
    usePosition.value = false;
}

const currentIdx = computed(() => usePosition.value ? idx.value : 0);

watch(currentIdx, (current, old) => {
    if (current !== old) {
        if (current < old) {
            direction.value = 'left';
        } else {
            direction.value = 'right';
        }
    }
})

</script>

<style lang="scss" src="./style.scss" scoped></style>